import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { RouterServiceModule } from "@hermes/utils-generic-services-router";

import { BindSPANavigationForCTADirective } from "./directives/bind-spa-navigation-for-cta.directive";
import { ResolveTokensPipe } from "./pipes/resolve-tokens.pipe";
import { EditoAnalyticsService } from "./services/edito-analytics.service";

@NgModule({
    imports: [
        CommonModule,
        RouterServiceModule,
        BindSPANavigationForCTADirective,
        ResolveTokensPipe,
    ],
    providers: [EditoAnalyticsService],
    exports: [BindSPANavigationForCTADirective, ResolveTokensPipe],
})
export class EditorialCTAResolverModule {}
